/* eslint-disable react/no-multi-comp */
import React, { Component, useState } from 'react';
import PropTypes from 'prop-types';
import { GroupDisabilityInsurance as SectionKey } from 'Consts/Questionnaire';
import { section } from 'Consts/Queries';
import { QueryVal } from 'Helpers/Query';
import CircleWithCount from 'Icons/CircleWithCount';
import { Box, Typography } from '@material-ui/core';
import { getClientPicklistValue, shouldMakeNotesFieldReadOnly } from './Helpers/ClientPicklist';
import LabeledVerticalExpander from '../UI/LabeledVerticalExpander';
import CurrencyInput from '../Fields/CurrencyInput';
import FieldList from '../Fields/FieldList';
import PercentageInput from '../Fields/PercentageInput';
import RadioInput from '../Fields/RadioInput';
import TextInput from '../Fields/TextInput';
import Section from '../Section';
import SelectInput from '../Fields/SelectInput';

class ShortTermDisabilityList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      shortTermDisabilityInsuranceInsuredClientId: '',
    };

    this.onChange = this.onChange.bind(this);
    this.getPolicyName = this.getPolicyName.bind(this);
  }

  onChange(name, value) {
    this.setState({ [name]: value });
  }

  getPolicyName() {
    const { insuredClientOptions } = this.props;
    const { shortTermDisabilityInsuranceInsuredClientId } = this.state;
    return shortTermDisabilityInsuranceInsuredClientId ? getClientPicklistValue(insuredClientOptions, shortTermDisabilityInsuranceInsuredClientId) : 'New policy';
  }

  render() {
    const {
      getPolicyName,
      onChange,
      props: {
        id, insuredClientOptions, children: removeButton, expanded,
      },
      state: {
        shortTermDisabilityInsuranceInsuredClientId,
      },
    } = this;
    return (
      <LabeledVerticalExpander
        transitionSpeed={0.15}
        title={getPolicyName()}
        removeButton={removeButton}
        expanded={expanded}
        firstElementFocusable
      >
        <SelectInput
          label="Insured"
          name={`shortTermDisabilityInsuranceInsuredClientId.${id}`}
          options={insuredClientOptions}
          answerKey="shortTermDisabilityInsuranceInsuredClientId"
          onChange={(name, value) => onChange('shortTermDisabilityInsuranceInsuredClientId', value)}
        />
        <TextInput
          placeholder="Insured Notes"
          name={`shortTermDisabilityInsuranceInsuredNotes.${id}`}
          answerKey="shortTermDisabilityInsuranceInsuredNotes"
          onChange={(name, value) => onChange('shortTermDisabilityInsuranceInsuredNotes', value)}
          readOnly={shouldMakeNotesFieldReadOnly(shortTermDisabilityInsuranceInsuredClientId)}
        />
        <CurrencyInput
          placeholder="Monthly benefit"
          name={`shortTermDisabilityInsuranceBenefit.${id}`}
          answerKey="shortTermDisabilityInsuranceBenefit"
        />
      </LabeledVerticalExpander>
    );
  }
}

ShortTermDisabilityList.propTypes = {
  id: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
  expanded: PropTypes.bool,
  insuredClientOptions: PropTypes.array.isRequired,
};

ShortTermDisabilityList.defaultProps = {
  expanded: false,
};

const longTermPayer = [
  {
    id: 'employer',
    text: 'Employer Paid',
  },
  {
    id: 'employee',
    text: 'Employee Paid',
  },
  {
    id: 'split',
    text: 'Split Cost',
  },
];

const coverageType = [
  {
    id: 'base',
    text: 'Base',
  },
  {
    id: 'bonus',
    text: 'Bonus',
  },
  {
    id: 'both',
    text: 'Both',
  },
];

class LongTermDisabilityList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      longTermDisabilityInsuranceInsuredClientId: '',
      longTermDisabilityInsurancePayer: '',
    };

    this.onChange = this.onChange.bind(this);
    this.getPolicyName = this.getPolicyName.bind(this);
    this.hasSplitCost = this.hasSplitCost.bind(this);
  }

  onChange(name, value) {
    this.setState({ [name]: value });
  }

  getPolicyName() {
    const { insuredClientOptions } = this.props;
    const { longTermDisabilityInsuranceInsuredClientId } = this.state;
    return longTermDisabilityInsuranceInsuredClientId ? getClientPicklistValue(insuredClientOptions, longTermDisabilityInsuranceInsuredClientId) : 'New policy';
  }

  hasSplitCost() {
    const { longTermDisabilityInsurancePayer } = this.state;
    return longTermDisabilityInsurancePayer === 'split';
  }

  render() {
    const {
      getPolicyName,
      hasSplitCost,
      onChange,
      props: {
        id, insuredClientOptions, children: removeButton, expanded,
      },
      state: { longTermDisabilityInsuranceInsuredClientId },
    } = this;
    return (
      <LabeledVerticalExpander
        transitionSpeed={0.15}
        title={getPolicyName()}
        removeButton={removeButton}
        firstElementFocusable
        expanded={expanded}
      >
        <SelectInput
          label="Insured"
          name={`longTermDisabilityInsuranceInsuredClientId.${id}`}
          options={insuredClientOptions}
          answerKey="longTermDisabilityInsuranceInsuredClientId"
          onChange={(name, value) => onChange('longTermDisabilityInsuranceInsuredClientId', value)}
        />
        <TextInput
          placeholder="Insured Notes"
          name={`longTermDisabilityInsuranceInsuredNotes.${id}`}
          answerKey="longTermDisabilityInsuranceInsuredNotes"
          onChange={(name, value) => onChange('longTermDisabilityInsuranceInsuredNotes', value)}
          readOnly={shouldMakeNotesFieldReadOnly(longTermDisabilityInsuranceInsuredClientId)}
        />
        <CurrencyInput
          placeholder="Monthly benefit ($ amount)"
          name={`longTermDisabilityInsuranceBenefit.${id}`}
          answerKey="longTermDisabilityInsuranceBenefit"
        />
        <PercentageInput
          placeholder="Monthly benefit (% of income)"
          name={`longTermDisabilityInsuranceBenefitPercent.${id}`}
          answerKey="longTermDisabilityInsuranceBenefitPercent"
        />
        <CurrencyInput
          placeholder="Maximum monthly benefit"
          name={`longTermDisabilityInsuranceMaximumBenefit.${id}`}
          answerKey="longTermDisabilityInsuranceMaximumBenefit"
        />
        <RadioInput
          label="Who pays for this benefit?"
          name={`longTermDisabilityInsurancePayer.${id}`}
          answerKey="longTermDisabilityInsurancePayer"
          options={longTermPayer}
          onChange={(name, value) => onChange('longTermDisabilityInsurancePayer', value)
          }
        />
        {hasSplitCost() && (
          <TextInput
            placeholder="Notes"
            name={`longTermDisabilityInsuranceNotes.${id}`}
            answerKey="longTermDisabilityInsuranceNotes"
          />
        )}
        <RadioInput
          label="Coverage Type"
          name={`longTermDisabilityInsuranceCoverageType.${id}`}
          answerKey="longTermDisabilityInsuranceCoverageType"
          options={coverageType}
          onChange={(name, value) => onChange('longTermDisabilityInsuranceCoverageType', value)
          }
        />
        <PercentageInput
          placeholder="% Coverage"
          name={`longTermDisabilityInsuranceCoveragePercent.${id}`}
          answerKey="longTermDisabilityInsuranceCoveragePercent"
        />
      </LabeledVerticalExpander>
    );
  }
}

LongTermDisabilityList.propTypes = {
  id: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
  expanded: PropTypes.bool,
  insuredClientOptions: PropTypes.array.isRequired,
};

LongTermDisabilityList.defaultProps = {
  expanded: false,
};

const GroupDisabilityInsurance = ({ insuredClientOptions }) => {
  const [shortCount, setShortTermCount] = useState(0);
  const [longTermCount, setLongTermCount] = useState(0);

  return (
    <Section
      CountComponent={<Box className="expander-header-multi-count expander-header-left"><Typography>Short Term</Typography><CircleWithCount count={shortCount} className="expander-header-count" /><Typography>Long Term</Typography><CircleWithCount count={longTermCount} className="expander-header-count" /></Box>}
      transitionSpeed={0.25}
      height={400}
      title="Group Disability Insurance"
      sectionKey={SectionKey}
      expanded={QueryVal(section) === SectionKey}
    >
      <FieldList
        onCountUpdate={setShortTermCount}
        id="short-term"
        label="Policy - short term disability"
        addLabel="Add a policy"
        keyPrefix="shortTermDisabilityInsurances"
        Of={ShortTermDisabilityList}
        childProps={{ insuredClientOptions }}
      />
      <FieldList
        onCountUpdate={setLongTermCount}
        id="long-term"
        label="Policy - long-term disability"
        addLabel="Add a policy"
        keyPrefix="longTermDisabilityInsurances"
        Of={LongTermDisabilityList}
        childProps={{ insuredClientOptions }}
      />
    </Section>
  );
};

GroupDisabilityInsurance.propTypes = {
  insuredClientOptions: PropTypes.array.isRequired,
};

export default GroupDisabilityInsurance;
